import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { selectPersona } from 'features/auth/ducks/selectors'
import { updateUserRoutine } from 'features/auth/ducks/actions'
import { bp } from 'features/dashboard/tokens'

const PERSONAS = [
  { value: 'manager', label: 'Manager' },
  { value: 'team_member', label: 'Team member' }
]

const PersonaSwitcher = () => {
  const dispatch = useDispatch()
  const persona = useSelector(selectPersona) || 'manager'

  const switchTo = value => {
    if (value !== persona) dispatch(updateUserRoutine({ persona: value }))
  }

  return (
    <Wrap>
      <Caption>View</Caption>
      <Toggle role='group' aria-label='Switch view'>
        {PERSONAS.map(p => (
          <Opt
            key={p.value}
            type='button'
            $active={persona === p.value}
            aria-pressed={persona === p.value}
            onClick={() => switchTo(p.value)}
          >
            {p.label}
          </Opt>
        ))}
      </Toggle>
    </Wrap>
  )
}

export default PersonaSwitcher

const Wrap = styled.div`
  display:inline-flex;align-items:center;gap:9px;

  @media (max-width: ${bp.mobile}) {
    display:flex;flex:1 1 100%;width:100%;gap:8px;
  }
`
const Caption = styled.span`font-size:12px;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;color:#64748b;`
const Toggle = styled.div`
  display:inline-flex;padding:3px;gap:3px;background:#f1f3f7;border:1px solid #e4e7ee;border-radius:10px;

  @media (max-width: ${bp.mobile}) {
    display:flex;flex:1 1 auto;min-width:0;
  }
`
const Opt = styled.button`
  font:inherit;font-size:13px;font-weight:700;padding:8px 15px;min-height:38px;border-radius:8px;cursor:pointer;
  white-space:nowrap;
  border:1px solid ${({ $active }) => ($active ? '#e2e5ea' : 'transparent')};
  background:${({ $active }) => ($active ? '#fff' : 'transparent')};
  color:${({ $active }) => ($active ? '#1b2233' : '#5b6472')};
  box-shadow:${({ $active }) => ($active ? '0 1px 2px rgba(20,30,60,0.06)' : 'none')};
  transition:background 130ms ease,color 130ms ease;
  &:hover{color:#1b2233;}

  @media (max-width: ${bp.mobile}) {
    flex:1 1 0;min-width:0;padding:8px 10px;min-height:40px;
  }
`
